import { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import {Link} from "react-router-dom";

const MahasiswaForm = ()=>{
    let {id} = useParams()
    let history = useHistory()
    const url = "https://backendexample.sanbercloud.com"
    const [inputNama, setInputNama] = useState([]);
    const [inputMatkul, setInputMatkul] = useState()
    const [inputNilai, setInputNilai] = useState()
    const [currentId, setCurrentId] = useState(null) // state for currentId (for handleEdit function)

    useEffect(()=>{
        // for get data edit form
        const fetchData = async ()=>{
            let result = await axios.get(`${url}/api/student-scores/${id}`)
            let currentMahasiswa = result.data
            // console.log(currentMahasiswa)
            setCurrentId(id)
            setInputNama(currentMahasiswa.name)
            setInputMatkul(currentMahasiswa.course)
            setInputNilai(currentMahasiswa.score)
        }
        if (id){
            fetchData()
        }       
    },[id])
    

    const handleSubmit = (event) =>{
        event.preventDefault()
        if (currentId === null){
            axios.post(`${url}/api/student-scores`, {name: inputNama, course: inputMatkul, score: inputNilai}).then(res=>{
                history.push("/nilai-mahasiswa")
            })
        } else {
            axios.put(`${url}/api/student-scores/${currentId}`, {name: inputNama, course: inputMatkul, score: inputNilai}).then(()=>{
                history.push("/nilai-mahasiswa")
            })
        }

        // clear form
        setCurrentId(null)
        setInputNama("")
        setInputMatkul()
        setInputNilai()
    }

    const handleNama = (event) => {
        let value = event.target.value
        setInputNama(value)
    }

    const handleMatkul = (event) => {
        let value = event.target.value
        setInputMatkul(value)
    }

    const handleNilai = (event) => {
        let value = event.target.value
        setInputNilai(value)
    }


    return(
        <>
        <h1 className='App'>Form Data Mahasiswa</h1>
        <div className='custom-form'>
            <form onSubmit={handleSubmit}>
                <div className='custom-input'>
                    <label htmlFor='name'>Nama :</label>
                    <input required autoComplete='off' type="text" name='name' value={inputNama} onChange={handleNama} placeholder="Masukkan Nama..." /> 
                    <label htmlFor='harga'>Mata Kuliah :</label>
                    <input required autoComplete='off' type="text" name='course' value={inputMatkul} onChange={handleMatkul} placeholder="Masukkan Mata Kuliah..." /> 
                    <label htmlFor='berat'>Nilai :</label>
                    <input required autoComplete='off' type="number" max="100" name='score' value={inputNilai} onChange={handleNilai} placeholder="Masukkan Nilai..." /> 
                </div>
                <input type="submit" value="Submit"/>
                <Link to="/nilai-mahasiswa"><button className="button-delete">Cancel</button></Link>
            </form>
        </div>
    </>
    )
}

export default MahasiswaForm